module.exports = __webpack_public_path__ + "static/media/Liechtenstein.8cb510ed.png";